import { Dispatch } from 'redux'

import { Part } from '../../../types/part/partTypes'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const setSellPartModal =
    (modalState: { part: Part | null; isOpen: boolean }) =>
    async (dispatch: Dispatch): Promise<void> => {
        dispatch({
            type: storeDispatchTypes.setSellPartModal,
            value: {
                part: modalState.part,
                isOpen: modalState.isOpen,
            },
        })
    }

export default setSellPartModal
